// styled.ts
import styled from "styled-components";

export const PageContainer = styled.div`
  width: 100%;
`;

/* --- Top Tabs --- */
export const TopBar = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const TabList = styled.div`
  display: flex;
  gap: 16px;
`;

export const Tab = styled.div`
  padding: 8px 12px;
  font-weight: 500;
  cursor: pointer;
  border-bottom: ${(p) => (p.active ? "3px solid #3FC4FD" : "3px solid transparent")};
  color: ${(p) => (p.active ? "#3FC4FD" : "#444")};
`;

export const AddNewBtn = styled.button`
  background: #3FC4FD;
  border: none;
  color: white;
  padding: 6px 12px;
  border-radius: 4px;
  cursor: pointer;
`;

/* --- Sub Tabs --- */
export const SubTabs = styled.div`
  display: flex;
  gap: 12px;
  margin: 16px 0;
  white-space: nowrap;
  overflow: hidden;
`;


export const SubTab = styled.div`
  padding: 6px 12px;
  border-radius: 4px;
  background: ${(p) => (p.active ? "#e6f0ff" : "transparent")};
  color: ${(p) => (p.active ? "#3FC4FD" : "#555")};
  cursor: pointer;
  border: ${(p) => (p.active ? "1px solid #3FC4FD" : "1px solid #ccc")};
`;

export const SelectHeader = styled.div`
  display: flex;
  margin-bottom: 10px;
  max-width: 300px;

  @media (max-width: 768px) {
    max-width: 100%;
  }
`

/* --- Channel Preview --- */
export const ChannelRow = styled.div`
  display: flex;
  gap: 24px;
  margin-bottom: 24px;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 10px;
  }
`;

export const Preview = styled.div`
  // flex: 1;
  border: 1px solid #ddd;
  border-radius: 6px;
  padding: 20px;
  width: 30%;

  @media (max-width: 768px) {
    width: calc(100% - 42px);
  }
  
`;

export const Preview2 = styled.div`
  width: 30%;
  padding: 20px;

  @media (max-width: 768px) {
    width: 100%;
    padding: 0;
  }
`;

export const PreviewBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const GrayLine = styled.div`
  height: 20px;
  background: ${(p) => p.bg || "#ccc"};
  opacity: 0.5;
  width: ${(p) => p.width || "80%"};
  border-radius: 4px;
`;

export const GrayBox = styled.div`
  height: 40px;
  background: #ddd;
  opacity: 0.5;
  border-radius: 6px;
`;

export const PreviewBtn = styled.div`
  width: 120px;
  height: 35px;
  background: ${(p) => p.color};
  border: 1px solid ${(p) => p.borderColor};
  border-radius: 4px;
`;

export const Customize = styled.div`
  flex: 1;
  border: 1px solid #ddd;
  border-radius: 6px;
  padding: 20px;
`;

export const Title = styled.h3`
  font-size: 16px;
  margin-bottom: 8px;
`;

export const Description = styled.p`
//   font-size: 14px;
  color: #666;
`;

export const LinkBox = styled.div`
  display: flex;
  margin: 12px 0;
`;

export const CopyBtn = styled.button`
  padding: 8px 12px;
  border: 1px solid #ccc;
  background: #fff;
  cursor: pointer;
`;

export const FormGroup = styled.div`
  margin-bottom: 16px;
  display: flex;
  flex-direction: column;
`;

export const Label = styled.label`
  margin-bottom: 6px;
  font-weight: 500;
`;

export const Input = styled.input`
  padding: 8px;
  font-size: 16px;
  border: 1px solid #ccc;
  border-radius: 4px;
`;
export const PrefixSpan = styled.span`
  padding: 8px;
  font-size: 16px;
  border: 1px solid #ccc;
  border-radius: 4px;
`;

export const Select = styled.select`
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
`;

export const Textarea = styled.textarea`
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
`;

export const ButtonRow = styled.div`
  display: flex;
  gap: 12px;
  margin-top: 20px;
`;

export const PrimaryBtn = styled.button`
  background: #3FC4FD;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
`;

export const DangerBtn = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  background: #f8d7da;
  color: #721c24;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;

  &:disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }
`;

/* --- Settings Tabs --- */
export const SettingsTabs = styled.div`
  display: flex;
  gap: 16px;
  margin-bottom: 16px;
`;

export const SettingsTab = styled.div`
  padding: 6px 12px;
  cursor: pointer;
  border-bottom: ${(p) => (p.active ? "3px solid #3FC4FD" : "3px solid transparent")};
  color: ${(p) => (p.active ? "#3FC4FD" : "#444")};
`;

/* --- Settings Panel --- */
export const Panel = styled.div`
  border: 1px solid #ddd;
  border-radius: 6px;
  padding: 20px;
`;

export const Section = styled.div`
  margin-bottom: 32px;
`;

export const SectionTitle = styled.h4`
  margin-bottom: 12px;
  font-size: 18px;
`;

export const ToggleRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
`;

/* Custom Switch */
export const Switch = styled.input.attrs({ type: "checkbox" })`
  width: 40px;
  height: 20px;
  appearance: none;
  background: #ccc;
  border-radius: 20px;
  position: relative;
  outline: none;
  cursor: pointer;
  transition: background 0.3s;

  &:checked {
    background: #3FC4FD;
  }

  &::before {
    content: "";
    position: absolute;
    width: 16px;
    height: 16px;
    top: 2px;
    left: 2px;
    background: white;
    border-radius: 50%;
    transition: transform 0.3s;
  }

  &:checked::before {
    transform: translateX(20px);
  }
`;

export const Poster = styled.div`
  background: #FFFFFF;
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 20px;
  padding: 100px;

  @media (max-width: 600px) {
    padding: 20px;
  }
`;
